<div class="is-flex is-column gap-16 is-fullheight">

  <div class="is-flex is-justify-space-between gap-16">
    <app-icon [routerLink]="['..']" skipLocationChange="true" class="text-24 is-cursor-pointer" name="back"></app-icon>
    <app-text class="text-20 is-family-semiBold">{{ 'common-app.__WEBAPP_HC_FUS_TITLE2' | AsyncLang | async }}</app-text>
    <app-icon [routerLink]="['/']"  skipLocationChange="true" (click)="close()" class="text-24 is-cursor-pointer" name="close"></app-icon>
  </div>

  <div>
    <app-text class="text-align-center">{{ 'common-app.__WEBAPP_HC_FUS_TEXT2' | AsyncLang | async }}</app-text>
  </div>

  <app-first-use-slide-image srcset="/assets/images/control-page/first-use-slides/multi-products.webp 1x,
    /assets/images/control-page/first-use-slides/multi-products@2x.webp 2x,
    /assets/images/control-page/first-use-slides/multi-products@3x.webp 3x">
  </app-first-use-slide-image>


  <div class="is-flex is-column gap-16">
    <lay-button class="is-flex-button" [routerLink]="['/']" skipLocationChange="true" (click)="close()">
      <button class="is-primary-button">
        <app-text [text]="'common-app.__DISCOVER' | AsyncLang | async"></app-text>
      </button>
    </lay-button>
  </div>

</div>